import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useWorkOrderFlow } from '@/hooks/useWorkOrderFlow';
import { useCalendarStatusOptions } from '@/features/calendar/useCalendarStatusOptions';
import { calendarColors, neutralGrey, statusColors } from '@/styles/theme';

/** Work order status colours, shown above the calendar so bars read at a glance. */
export function CalendarStatusLegend() {
  const { t } = useTranslation('calendar');
  const { statusColors: flowColors } = useWorkOrderFlow();
  const statuses = useCalendarStatusOptions();
  if (statuses.length === 0) return null;
  return (
    <Box component="ul" aria-label={t('legend.statusTitle')}
      sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: 1.5, rowGap: 0.5,
        listStyle: 'none', m: 0, p: 0, minWidth: 0 }}>
      {statuses.map((status) => (
        <Box component="li" key={status} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box aria-hidden sx={{
            width: 12, height: 12, borderRadius: 0.5, flexShrink: 0,
            border: `1px solid ${calendarColors.itemBorder}`,
            backgroundColor: (statusColors as Record<string, string>)[status] ?? flowColors[status] ?? neutralGrey,
          }} />
          <Typography variant="caption" noWrap>{t(`statusLabels.${status}`, { defaultValue: status })}</Typography>
        </Box>
      ))}
    </Box>
  );
}
